module.exports = __webpack_public_path__ + "img/107ne.32bc600f.svg";